import styled from "styled-components"

export const Container = styled.hr`
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin: 15px 0;
`
